import { PageHeader } from "@/components/shared/PageHeader";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { PrimaryButton } from "@/components/shared/Buttons";
import { CollegeSessionForm } from "@/components/shared/CollegeSessionForm";
import { useSeo } from "@/hooks/useSeo";

const offerings = [
  { title: "On-campus AI training", text: "Bring applied AI programs directly to your students." },
  { title: "Internship pipelines", text: "Structured pathways connecting learning to experience." },
  { title: "Faculty collaboration", text: "Work with our team to build AI capability on campus." },
  { title: "Workshops & sessions", text: "Expert-led sessions tailored to your institution." },
];

export default function CollegePartnerships() {
  useSeo("College Partnerships", "Partner with ASAI to bring industry-focused AI training, internships and expert sessions to your college or university. Request a college expert session.");
  return (
    <div data-testid="page-college-partnerships">
      <PageHeader
        overline="For Colleges"
        titleLines={["Bring applied AI", "onto your campus"]}
        description="We partner with colleges to deliver industry-focused AI training, internships and expert sessions for students."
      />

      <section className="bg-white py-24 md:py-32">
        <div className="container-asai">
          <SectionHeading overline="Partnership offerings" title="Ways we collaborate" />
          <StaggerGroup className="mt-14 grid gap-6 sm:grid-cols-2">
            {offerings.map((o) => (
              <StaggerItem key={o.title} className="rounded-2xl border border-navy/10 bg-lightgrey p-8">
                <h3 className="font-heading text-2xl text-navy">{o.title}</h3>
                <p className="mt-3 text-navy/65">{o.text}</p>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>

      <section className="bg-navy py-24 md:py-28" id="request-session">
        <div className="container-asai grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
          <SectionHeading onDark overline="Invite an Expert" title="Request a college expert session" description="Tell us about your institution and we'll coordinate an industry expert session for your students." />
          <CollegeSessionForm onDark />
        </div>
      </section>

      <section className="bg-lightgrey py-20 md:py-24">
        <div className="container-asai flex flex-col items-start gap-6">
          <SectionHeading overline="Prefer to talk first?" title="Let's build AI talent together" />
          <PrimaryButton to="/contact" size="lg" withArrow testId="colleges-contact-btn">
            Start a conversation
          </PrimaryButton>
        </div>
      </section>
    </div>
  );
}
